import type { HalIncotermsListResponse } from './api';

export const normalizeHalIncotermsList = (list: HalIncotermsListResponse): { label: string; value: string }[] => {
  if (!list || !Array.isArray(list)) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeId,
    value: row.codeId,
  }));
};
